import { Common } from './Common';

export class Feed extends Common {
    status: string;
    type: string;
    category: string;
    allowed_master: string;
    allowed_reaction: string;
    creator: any;
    header: string;
    description: string;
    event_date: Date;
    image_urls: any;
    reaction_count: any;

    reactionKeys: string[];

    json_details: any;
}
